'use client';

import { useMagneticButton } from '@/app/utils/useMagneticButton';
import Image from 'next/image';
import styles from '../shop.module.css';
import Link from 'next/link';

export default function ProductCard({ supplement, cardRef }) {
  const magneticProps = useMagneticButton(0.2, 1.02);

  return (
    <div ref={cardRef} className={styles.productCard}>
      <div className={styles.productCardContent}>
        <div className={styles.badge}>NEW</div>
        <div className={styles.heartIcon}>♡</div>
        <div className={styles.imageContainer}>
          <Image
            src={supplement.image}
            className={styles.productImage}
            alt={supplement.name}
            fill
            sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
            style={{ objectFit: 'contain' }}
            unoptimized
            priority={false}
          />
          <div className={styles.imageGlow}></div>
        </div>

        <div className={styles.hoverButton}>
        <Link href={"/product/"+supplement.link} > <button
            className={styles.addToCartBtn}
            {...magneticProps}
          >
            <span>Add to Cart</span>
            <span className={styles.cartIcon}>→</span>
          </button></Link>
        </div>
      </div>
      <div className={styles.productInfo}>
        <div className={styles.rating}>
          <span className={styles.stars}>★★★★★</span>
          <span className={styles.reviewCount}>(127)</span>
        </div>
        <h3 className={styles.productName}>{supplement.name}</h3>
        <p className={styles.productDescription}>Premium formula for optimal results</p>
        <div className={styles.priceRow}>
          <p className={styles.productPrice}>{supplement.price}dt</p>
          <span className={styles.stock}>In Stock</span>
        </div>
      </div>
    </div>
  );
}
